(function ($) {

    if (TL.Signin === undefined) {
        TL.Signin = {};
    }

    var google = {
      
        handleCredentialResponse(response) {
                    
            TL.Signin.Google.getInfo(response.credential);     
        },

        getInfo(credential) {
   
            var announce = $('#social-media-signin-form');
            if (announce) {

                $('#social-media-signin-form input[name="google-jwt-response"]').val(credential);

                //Call remote command
                return submitGoogleSignJwtResponse();
            }
        },
        

        getName() {

            var name = Cookies.get('TL_GOOGLE_GIVENNAME');
            return name;

        },


        googleSetDataToInput(credential, user) {                                                
                        
            if (user !== '') {
                
                var profile = JSON.parse(user);

                //Submit form
                TL.Signin.Progress.submitData('google',
                                              profile.sub,
                                              profile.given_name,
                                              profile.family_name,
                                              profile.email);   
                                                        
                
                TL.Signin.Google.createCookies(credential, profile.given_name, profile.family_name, profile.email);

            }
        },
        
        
        createCookies(credential, givenName, familyName, email) {
                 
        },
                        
        removeCookies() {

        },       
                
                
        onLoad() {                        
  
        },
        
        
        logout() {
            
           TL.Signin.Google.removeCookies();
        }
    }

    if (TL.Signin.Google === undefined) {
        TL.Signin.Google = google;
    }
    
})(jQuery);

